import { render, staticRenderFns } from "./aliplayer.vue?vue&type=template&id=38b43838"
import script from "./aliplayer.vue?vue&type=script&lang=js"
export * from "./aliplayer.vue?vue&type=script&lang=js"
import style0 from "./aliplayer.vue?vue&type=style&index=0&id=38b43838&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports